import React from 'react';
import QuickRecruitmentForm from './QuickRecruitmentForm';
export default function EmployerPage(){return <QuickRecruitmentForm employer/>;}
